import { GenericError, errorMessage } from '../../../../utils/errors';
import { fetchJSON } from '../../../../utils/fetch';

import { rootStore } from '../../../root-store';
import { featureAppStoreActions } from '../../feature-app-store';

interface VictorCksCacheKeyResponse {
	readonly key: string;
}

export async function fetchVictorCacheKey(): Promise<string | undefined> {
	const victorServiceConfig = featureAppStoreActions.getServiceConfig('oneapi-victor');
	if (!victorServiceConfig) {
		errorMessage('Unable to get victorServiceConfig please check you are not in a no-victor market');
		return;
	}

	const [_, currentModelValue] = rootStore.currentModel.get();
	if (!currentModelValue) {
		errorMessage('Unable to get currentModel from store, please contact dev team');
		return;
	}

	const { tenant } = currentModelValue.vehicleConfiguration || { tenant: '' };
	const { urlPath, urlOrigin, credentials } = victorServiceConfig;

	const url = `${urlOrigin}${urlPath || ''}/cks/cachekey/${tenant}`;

	if (!tenant) throw new GenericError('Tenant is not defined');

	const response = await fetchJSON<VictorCksCacheKeyResponse>({ url, credentials });

	if (!response) {
		throw new GenericError(`Couldn't load VICTOR cache key with tenant ${tenant}. Contact Victor team`);
	}

	return response.key;
}
